/**
 * @name 组件注册
 * @description 注册需要对外提供的组件
 * @author liuguisheng
 * @version 2019-12-9
 * 
*/

import RiceIndex from './RiceIndex/index.js';
import RicePreviewBridge from './RicePreviewBridge/index.js';
import RicePreviewForm from './RicePreviewForm/index.js';
import RicePreviewRender from './RicePreviewRender/index.js';

const components = [
  RiceIndex,
  RicePreviewBridge,
  RicePreviewForm,
  RicePreviewRender
];


export default function ( Vue ) {
    components.map(component => {
      Vue.component(component.name, component)
    })
}


//////////////////
// WEBPACK FOOTER
// ./packages/index.js
// module id = null
// module chunks = 